module.exports = __webpack_public_path__ + "img/shipo-icon-stopwatch-pause.9a6ffe54.svg";